import { connect } from 'react-redux';
import Nuclei from '../components/Nuclei';
import { updateCellPopulationChoice, updateCellPopulationOrder } from '../actions/cell_population';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
  cellPopOrder: 'alpha',
});

const mapDispatchToProps = dispatch => ({
  actions: {
    updateCellPopulationChoice: (target) => {
      dispatch(updateCellPopulationChoice(target));
    },
    updateCellPopulationOrder: (target) => {
      dispatch(updateCellPopulationOrder(target));
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Nuclei);



// WEBPACK FOOTER //
// ./src/containers/Nuclei.js